import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";
import "./hm-theme.css";

const DisclaimerPopup = ({ isOpen, onRequestClose, userid}) => {
  const [employeeDetails, setEmpDetails] = useState(null);
  const [compDetails, setCompanyDetails] = useState(null);
  const [designations, setDesignations] = useState(null);
  const [financialYearSettings, setFinancialYearSettings] = useState(null);
  const [annualCheckup, setAnnualCheckup] = useState(null);
  const [locationMapping, setLocationMapping] = useState(null);
  const [packageMapping, setPackageMapping] = useState(null);
  const [employeeEnabled, setEmployeeEnabled] = useState(null);
  const [loader, setLoader] = useState(false);
  const [designationErrorModal, setDesignationErrorModal] = useState(false);
  const [yearSettingsErrorModal, setYearSettingErrorModal] = useState(false);
  const [annualCheckupErrorModal, setAnnualCheckuperrorModal] = useState(false);
  const [packageMappingErrorModal, setPackageMappingErrorModal] = useState(false);
  const [locationMappingErrorModal, setLocationMappingErrorModal] = useState(false);
  const [employeeEnabledErrorModal, setEmployeeEnabledErrorModal] = useState(false);

  const navigate = useNavigate();

  const handleBookAppointment = () => {
    navigate(`/users/book-appointment/${userid}`);
  };

  const getData = async () => {
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    setLoader(true);
    try {
      const empRes = await axios.get(`/api/employeedetails/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmpDetails(empRes.data);
      const compRes = await axios.get(`/api/companydetails/${empRes.data?.companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanyDetails(compRes.data);
      const designationRes = await axios.get(`/api/employeedetails/checkDesignationMapped/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDesignations(designationRes.data);

      const locationRes = await axios.get(`/api/employeedetails/checkLocationMapped/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLocationMapping(locationRes.data);

      const yearSettings = await axios.get(`/api/year-settings/checkFinancialYears`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFinancialYearSettings(yearSettings.data);

      const enableRes = await axios.get(`/api/employeedetails/checkEmplyeeEnabled/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmployeeEnabled(enableRes.data);

      const packageRes = await axios.get(`/api/employeedetails/checkPackageMapped/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPackageMapping(packageRes.data);

      const annualCheckup = await axios.get(`/api/employeedetails/checkAnnualCheckup/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAnnualCheckup(annualCheckup.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const allDetailsTrue =
    designations?.allAccounted === true &&
    financialYearSettings?.allAccounted === true &&
    annualCheckup?.allAccounted === true &&
    packageMapping?.allAccounted === true &&
    employeeEnabled?.allAccounted === true &&
    locationMapping?.allAccounted === true;

  const closeDesignationErrorModal = () => {
    setDesignationErrorModal(false);
  };

  const closeYearSettingErrorModal = () => {
    setYearSettingErrorModal(false);
  };

  const closeAnnualCheckupErrorModal = () => {
    setAnnualCheckuperrorModal(false);
  };

  const closePackageErrorModal = () => {
    setPackageMappingErrorModal(false);
  };

  const closeLocationErrorModal = () => {
    setLocationMappingErrorModal(false);
  };

  const closeEmployeeEnabledErrorModal = () => {
    setEmployeeEnabledErrorModal(false);
  };

  return (
    <>
      <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h5 fw-bold mb-0 d-flex align-items-center gap-2" style={{ color: "#1e293b" }}>
            <i className="material-icons text-primary">gavel</i>
            Terms & Disclaimer
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {loader && <div className="loading"></div>}

          <div className="row g-4">
            {/* Left Side: Conditions */}
            <div className="col-md-5 border-end pe-md-4">
              <h6 className="fw-bold mb-3" style={{ color: "#1e293b" }}>Eligibility Checklist</h6>
              
              <div className="d-flex align-items-center justify-content-between mb-2 p-2 rounded bg-light">
                <span className="small fw-semibold text-secondary">Designation</span>
                <div className="d-flex align-items-center gap-2">
                  {designations?.allAccounted === true ? (
                    <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded-pill small">✓ Verified</span>
                  ) : (
                    <>
                      <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1 rounded-pill small">❌ Pending</span>
                      <FiInfo className="text-primary cursor-pointer" onClick={() => setDesignationErrorModal(true)} />
                    </>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between mb-2 p-2 rounded bg-light">
                <span className="small fw-semibold text-secondary">Location</span>
                <div className="d-flex align-items-center gap-2">
                  {locationMapping?.allAccounted === true ? (
                    <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded-pill small">✓ Verified</span>
                  ) : (
                    <>
                      <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1 rounded-pill small">❌ Pending</span>
                      <FiInfo className="text-primary cursor-pointer" onClick={() => setLocationMappingErrorModal(true)} />
                    </>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between mb-2 p-2 rounded bg-light">
                <span className="small fw-semibold text-secondary">Enabled Personnel</span>
                <div className="d-flex align-items-center gap-2">
                  {employeeEnabled?.allAccounted === true ? (
                    <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded-pill small">✓ Verified</span>
                  ) : (
                    <>
                      <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1 rounded-pill small">❌ Pending</span>
                      <FiInfo className="text-primary cursor-pointer" onClick={() => setEmployeeEnabledErrorModal(true)} />
                    </>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between mb-2 p-2 rounded bg-light">
                <span className="small fw-semibold text-secondary">Financial Year Settings</span>
                <div className="d-flex align-items-center gap-2">
                  {financialYearSettings?.allAccounted === true ? (
                    <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded-pill small">✓ Verified</span>
                  ) : (
                    <>
                      <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1 rounded-pill small">❌ Pending</span>
                      <FiInfo className="text-primary cursor-pointer" onClick={() => setYearSettingErrorModal(true)} />
                    </>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between mb-2 p-2 rounded bg-light">
                <span className="small fw-semibold text-secondary">Package Mapping</span>
                <div className="d-flex align-items-center gap-2">
                  {packageMapping?.allAccounted === true ? (
                    <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded-pill small">✓ Verified</span>
                  ) : (
                    <>
                      <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1 rounded-pill small">❌ Pending</span>
                      <FiInfo className="text-primary cursor-pointer" onClick={() => setPackageMappingErrorModal(true)} />
                    </>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between mb-2 p-2 rounded bg-light">
                <span className="small fw-semibold text-secondary">Annual Health Checkup</span>
                <div className="d-flex align-items-center gap-2">
                  {annualCheckup?.allAccounted === true ? (
                    <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 rounded-pill small">✓ Verified</span>
                  ) : (
                    <>
                      <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1 rounded-pill small">❌ Pending</span>
                      <FiInfo className="text-primary cursor-pointer" onClick={() => setAnnualCheckuperrorModal(true)} />
                    </>
                  )}
                </div>
              </div>

              {!allDetailsTrue && (
                <div className="alert alert-danger p-2 mt-3 mb-0 small text-center rounded border-0">
                  Please contact your administration for the pending requirements above.
                </div>
              )}
            </div>

            {/* Right Side: Disclaimer */}
            <div className="col-md-7 ps-md-4 text-justify">
              <h6 className="fw-bold mb-3" style={{ color: "#1e293b" }}>Disclaimer</h6>
              <p className="small text-muted mb-3" style={{ lineHeight: "1.6" }}>
                Executive annual medicals for <strong className="text-dark">{compDetails?.companyname || "your organization"}</strong> are facilitated by TMPL, providing multiple medical facilities across India for the convenience of executives. The choice of the available center lies with the executive. All processes followed by the selected center must be adhered to by the executive meticulously, for best results.
              </p>

              <p className="small text-muted mb-0" style={{ lineHeight: "1.6" }}>
                TMPL has no role in the execution of specified tests or reporting by the center based on the results; this interaction is solely between the executive and the center. Positive identification is mandatory between the center and the executive. Any additional tests require approval by the respective HR. TMPL is only responsible for scheduling appointments through its portal and access of reports by the center to authorized personnel.
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-3">
          <Button variant="outline-secondary" className="rounded-pill px-4 me-2" onClick={onRequestClose}>
            Decline
          </Button>
          {allDetailsTrue && (
            <button className="btn-hm-primary px-4" onClick={handleBookAppointment}>
              Accept
            </button>
          )}
        </Modal.Footer>
      </Modal>
    
      <Modal show={designationErrorModal} onHide={closeDesignationErrorModal} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-danger">Designation Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-danger small mb-0">{designations?.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="secondary" className="btn-sm rounded-pill px-3" onClick={closeDesignationErrorModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={yearSettingsErrorModal} onHide={closeYearSettingErrorModal} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-danger">Financial Year Settings Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-danger small mb-0">{financialYearSettings?.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="secondary" className="btn-sm rounded-pill px-3" onClick={closeYearSettingErrorModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={annualCheckupErrorModal} onHide={closeAnnualCheckupErrorModal} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-danger">Annual Checkup Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-danger small mb-0">{annualCheckup?.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="secondary" className="btn-sm rounded-pill px-3" onClick={closeAnnualCheckupErrorModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={locationMappingErrorModal} onHide={closeLocationErrorModal} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-danger">Location Mapping Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-danger small mb-0">{locationMapping?.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="secondary" className="btn-sm rounded-pill px-3" onClick={closeLocationErrorModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={employeeEnabledErrorModal} onHide={closeEmployeeEnabledErrorModal} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-danger">Enabled Personnel Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-danger small mb-0">{employeeEnabled?.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="secondary" className="btn-sm rounded-pill px-3" onClick={closeEmployeeEnabledErrorModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={packageMappingErrorModal} onHide={closePackageErrorModal} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-danger">Package Mapping Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-danger small mb-0">{packageMapping?.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="secondary" className="btn-sm rounded-pill px-3" onClick={closePackageErrorModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DisclaimerPopup;

